function BottomBanner( {imgUrl} ) {
    return (
        <div className="bottom-banner"></div>
    )
}

export default BottomBanner;
            